import {collection, doc, getFirestore, setDoc} from 'firebase/firestore';
import {useEffect, useState} from 'react';
import {Modal} from 'react-bootstrap';
import {
  useCollectionData,
  useDocumentData,
} from 'react-firebase-hooks/firestore';
import Select from 'react-select';
import {githubUrl} from './utils';
import {getAuth} from 'firebase/auth';

export const ZipEditor = () => {
  const db = getFirestore();
  getAuth();
  const zipDocRef = doc(db, 'course', 'humanities', 'docs', 'zips');
  const [zipDocData, zipDocDataLoading, zipDocDataError] =
    useDocumentData(zipDocRef);
  const [assignmentsLoading, setAssignmentsLoading] = useState(true);
  const [assignments, setAssignments] = useState([]);
  const [showAddDayModal, setShowAddDayModal] = useState(false);
  const [zipsData, setZipsData] = useState([]);

  useEffect(() => {
    if (zipsData && !zipDocDataLoading) {
      const setZipDoc = async () => {
        await setDoc(zipDocRef, {
          zips: zipsData,
        });
      };
      setZipDoc();
    }
  }, [zipsData]);

  useEffect(() => {
    if (zipDocData && zipDocData.zips) {
      setZipsData(zipDocData.zips);
    }
  }, [zipDocData, zipDocDataLoading]);

  useEffect(() => {
    const loadAssignmentsFromRepo = async () => {
      // Fetch the assignments from the GitHub repository
      const response = await fetch(githubUrl);
      const assignmentsInRepo = await response.json();

      // Update the state with the fetched assignments
      console.log('Assignments in repo:', assignmentsInRepo);
      setAssignments(
        assignmentsInRepo.map(assn => {
          return {
            label: assn.name,
            value: assn.name,
            url: assn.url,
          };
        }),
      );
      setAssignmentsLoading(false);
    };
    loadAssignmentsFromRepo();
  }, []);

  if (zipDocDataLoading || assignmentsLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="d-flex flex-column w-100 justify-content-center align-items-center">
      <h1>Zip Editor</h1>
      <button
        className="btn btn-primary"
        onClick={() => setShowAddDayModal(true)}
      >
        Add Day
      </button>
      <AddDayModal
        show={showAddDayModal}
        setShow={setShowAddDayModal}
        assignments={assignments}
        dayData={{}}
        setDayData={data => {
          setZipsData(prev => [...prev, data]);
        }}
      />
      {zipsData.map(
        (dayData, index) => (
          console.log('Day data:', dayData),
          (
            <DayView
              key={index}
              index={index}
              dayData={dayData}
              setDayData={data => {
                setZipsData(prev => {
                  const newData = [...prev];
                  newData[index] = data;
                  return newData;
                });
              }}
              assignments={assignments}
              removeDay={dayIndex => {
                setZipsData(prev => prev.filter((_, i) => i !== dayIndex));
              }}
            />
          )
        ),
      )}
    </div>
  );
};

const AddDayModal = ({show, setShow, assignments, dayData, setDayData}) => {
  const [day, setDay] = useState(dayData.day || '');
  const [selectedAssignments, setSelectedAssignments] = useState(
    dayData.assignments || [],
  );
  const [isReleased, setIsReleased] = useState(dayData.isReleased || false);

  useEffect(() => {
    // Reset the form when the modal is closed
    if (!show) {
      setDay(dayData.day || '');
      setSelectedAssignments(dayData.assignments || []);
      setIsReleased(dayData.isReleased || false);
    }
  }, [show, dayData]);

  return (
    <Modal
      show={show}
      onHide={() => {
        setShow(false);
        setDayData({
          day: day,
          assignments: selectedAssignments,
          isReleased: isReleased,
        });
      }}
      centered
    >
      <Modal.Header closeButton onHide={() => setShow(false)}>
        <Modal.Title>Add Day</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Form to add a day */}
        <label htmlFor="day-select">What Day is this for:</label>
        <input
          type="text"
          className="form-control mb-3"
          id="day-select"
          value={day}
          onChange={e => setDay(e.target.value)}
          placeholder="Enter day name or number"
        />
        <label htmlFor="assn-select">Select Assignments to be Zipped:</label>
        <Select
          id="assn-select"
          options={assignments}
          isMulti
          className="mb-3"
          classNamePrefix="select"
          placeholder="Select assignments to zip"
          value={selectedAssignments}
          onChange={selectedOptions => {
            console.log('Selected options:', selectedOptions);
            setSelectedAssignments(selectedOptions || []);
          }}
          closeMenuOnSelect={false}
        />
        <label htmlFor="is-released">Is this assignment released?</label>
        <input
          type="checkbox"
          className="form-check-input mb-3"
          id="is-released"
          checked={isReleased}
          onChange={e => setIsReleased(e.target.checked)}
        />
      </Modal.Body>
    </Modal>
  );
};

const DayView = ({index, dayData, setDayData, assignments, removeDay}) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [zipping, setZipping] = useState(false);

  return (
    <div
      className="d-flex flex-column p-3 border rounded mb-3"
      style={{
        width: '600px',
      }}
    >
      <h3>{dayData.day || `Day ${index + 1}`}</h3>
      <div className="mb-3">
        <strong>Assignments:</strong>
        <ul>
          {dayData.assignments &&
            dayData.assignments.map((assn, idx) => (
              <li key={idx}>
                <a href={assn.url} target="_blank" rel="noopener noreferrer">
                  {assn.label}
                </a>
              </li>
            ))}
        </ul>
      </div>
      <div className="mb-3">
        <strong>Released:</strong>
        {dayData.isReleased ? 'Yes' : 'No'}
      </div>
      <button
        className="btn btn-secondary mb-2"
        onClick={() => setShowEditModal(true)}
      >
        Edit Day
      </button>
      <AddDayModal
        show={showEditModal}
        setShow={setShowEditModal}
        assignments={assignments} // Pass the assignments prop if needed
        dayData={dayData}
        setDayData={setDayData}
      />
      <button
        className="btn btn-danger"
        onClick={async () => {
          setZipping(true);
          try {
            await downloadZip(dayData);
          } catch (error) {
            console.error('Error downloading zip:', error);
            alert('Failed to download zip. Please try again.');
          }
          setZipping(false);
        }}
        disabled={zipping}
      >
        {zipping ? 'Zipping...' : 'Download Zip'}
      </button>
      <button className="btn btn-danger mt-2" onClick={() => removeDay(index)}>
        Remove Day
      </button>
    </div>
  );
};

export const downloadZip = async dayData => {
  // pull the assignments from github
  // and create a zip file
  // const dayAssnFileTree = {};
  // for (const assn of dayData.assignments) {
  //   dayAssnFileTree[assn.value] = {};
  //   const response = await fetch(assn.url);
  //   const data = await response.json();
  //   for (const file of data) {
  //     if (file.type === 'file') {
  //       const fileName = file.name;
  //       if (fileName === 'solution.py') {
  //         // Skip the solution file
  //         continue;
  //       }
  //       const fileResponse = await fetch(file.download_url);
  //       const fileContent = await fileResponse.text();
  //       dayAssnFileTree[assn.value][fileName] = fileContent;
  //     } else if (file.type === 'dir') {
  //       // If it's a directory, you can recursively fetch its contents
  //       const subFolderContent = await fetchFolderContent(file.url);
  //       dayAssnFileTree[assn.value][file.name] = subFolderContent;
  //     }
  //   }
  // }

  // turn the dayAssnFileTree into a zip file
  // const JSZip = (await import('jszip')).default;
  // const zip = new JSZip();
  // for (const [assnName, files] of Object.entries(dayAssnFileTree)) {
  //   const assnFolder = zip.folder(assnName);
  //   for (const [fileName, fileContent] of Object.entries(files)) {
  //     if (typeof fileContent === 'string') {
  //       assnFolder.file(fileName, fileContent);
  //     } else {
  //       // If it's a folder, we can recursively add its contents
  //       const addFilesRecursively = (folder, content) => {
  //         for (const [subFileName, subFileContent] of Object.entries(content)) {
  //           if (typeof subFileContent === 'string') {
  //             folder.file(subFileName, subFileContent);
  //           } else {
  //             const subFolder = folder.folder(subFileName);
  //             addFilesRecursively(subFolder, subFileContent);
  //           }
  //         }
  //       };
  //       addFilesRecursively(assnFolder, fileContent);
  //     }
  //   }
  // }
  // // Generate the zip file
  // const zipBlob = await zip.generateAsync({type: 'blob'});
  
  // Create a link to download the zip (in public folder called "day4.zip")
  // const zipBlob = new Blob([JSON.stringify(dayData)], {type: 'application/json'});
  // const url = URL.createObjectURL(zipBlob);
  // const link = document.createElement('a');
  
  // URL.revokeObjectURL(url);
};

const fetchFolderContent = async url => {
  const response = await fetch(url);
  const data = await response.json();
  const folder = {};
  for (const file of data) {
    if (file.type === 'file') {
      const fileName = file.name;
      if (fileName === 'solution.py') {
        // Skip the solution file
        continue;
      }
      const fileResponse = await fetch(file.download_url);
      const fileContent = await fileResponse.text();
      // Do something with the file content, e.g., store it in state
      folder[fileName] = fileContent;
    } else if (file.type === 'dir') {
      // If it's a directory, you can recursively fetch its contents
      const subFolderContent = await fetchFolderContent(file.url);
      folder[file.name] = subFolderContent;
    }
  }

  return folder;
};
